import MobilePlug from './solveig'

export default MobilePlug
